export default __webpack_public_path__ + "static/media/b-4.a5f1bee6.png";